module.exports = __webpack_public_path__ + "img/part-three-thumb_mobile.83f10d1.jpg";